import { createSelector } from 'reselect';
import last from 'lodash/last';

const SOURCES = {
    brokers: {},
    orders: {
        OSE: 'feed.ose.orders.EQUITIES',
        OAX: 'feed.oax.orders.EQUITIES',
        MERK: 'feed.merk.orders.EQUITIES',
    },
    trades: {
        OSE: 'feed.ose.trades.INSTRUMENTS',
        OAX: 'feed.oax.trades.INSTRUMENTS',
        MERK: 'feed.merk.trades.INSTRUMENTS',
    },
};

export const getSymbolsByMarketSourceSorted = createSelector(
    [
        (state, props) => (
            state.markets.hasOwnProperty(props.source) ? state.markets[props.source].list : []
        ),
        state => state.tickers,
    ],
    (symbols, tickers) => symbols.sort((a, b) => {
        const tickerA = tickers[a];
        const tickerB = tickers[b];

        if (!tickerA || !tickerB) {
            return 0;
        }

        return tickerA.CHANGE_PCT > tickerB.CHANGE_PCT;
    })
);

export function extractMarketFromSymbol(symbol) {
    const parts = symbol.split(/[\.\_]/);

    if (parts.length > 1) {
        return last(parts).toUpperCase();
    }

    return null;
}

export function getTradesSourceForSymbol(symbol) {
    const market = extractMarketFromSymbol(symbol);

    return SOURCES.trades[market] ? SOURCES.trades[market] : null;
}

export function getOrdersSourceForSymbol(symbol) {
    const market = extractMarketFromSymbol(symbol);

    return SOURCES.orders[market] ? SOURCES.orders[market] : null;
}



/** WEBPACK FOOTER **
 ** /src/shared/selectors/index.js
 **/